export var BaySearchEnum;
(function (BaySearchEnum) {
    BaySearchEnum["tradingSiteDescription"] = "Trading Site Description";
    BaySearchEnum["tradingSiteTown"] = "Trading Site Town";
    BaySearchEnum["tradingSiteStatus"] = "Trading Site Status";
    BaySearchEnum["size"] = "Size";
    BaySearchEnum["status"] = "Status";
})(BaySearchEnum || (BaySearchEnum = {}));
export var BaySearchOption;
(function (BaySearchOption) {
    BaySearchOption["Bay"] = "Bay";
})(BaySearchOption || (BaySearchOption = {}));
